import {
    createSlice,
    PayloadAction,
    createAction,
} from "@reduxjs/toolkit";

interface State {
    loading: boolean;
    error: string | null;
    cableTotalLength: number;
    cableSurfaceVoltage: number;
    cableTotalVoltageLoss: number;
    cableVoltageLoss1000: number;
    cableMaxCondutorTemp: number;
    cableConductorTempDesign: number;
    cableAmpacity: number;
    cableVDrop: number;
    wellCableList: any;
    lockPlateList: any;
    motorLeadList: any;
    ShowEquipmentTable: boolean;
    ShowEquipmentCableTable: boolean;
    wellEquipmentList: any;
    selectedWellEquipment: any;
    motorLockEquipmentList: any;
    selectedWellLockEquipment: any;
    cableClearance: any;
    tubingCableChart: any;
    pumpMotorLeadChart: any;
    sealMotorLeadChart: any;
    motorChart: any;
    cableCalculationComplete: boolean;
    selectedCable: any;
}

export const initialState: State = {
    loading: false,
    error: null,
    cableTotalLength: 0,
    cableSurfaceVoltage: 0,
    cableTotalVoltageLoss: 0,
    cableVoltageLoss1000: 0,
    cableMaxCondutorTemp: 0,
    cableConductorTempDesign: 0,
    cableAmpacity: 0,
    cableVDrop: 0,
    wellCableList: [],
    lockPlateList: [],
    motorLeadList: [],
    ShowEquipmentTable: false,
    ShowEquipmentCableTable: false,
    wellEquipmentList: [],
    selectedWellEquipment: [{}],
    motorLockEquipmentList: [],
    selectedWellLockEquipment: [{}],
    cableClearance: {},
    tubingCableChart: {},
    pumpMotorLeadChart: {},
    sealMotorLeadChart: {},
    motorChart: {},
    cableCalculationComplete: false,
    selectedCable: {},
};

export const fetchCableWellEquipment = createAction("cable/fetchCableWellEquipment");
export const fetchCableMotorEquipment = createAction("cable/fetchCableMotorEquipment");
export const fetchRefreshChart = createAction("cable/refreshChart");


const cableSlice = createSlice({
    name: "cable",
    initialState,
    reducers: {
        resetCableOutput: () => initialState,

        setCableTotalLength: (state, action) => {
            state.cableTotalLength = action.payload
        },
        setCableSurfaceVoltage: (state, action) => {
            state.cableSurfaceVoltage = action.payload
        },
        setCableTotalVoltageLoss: (state, action) => {
            state.cableTotalVoltageLoss = action.payload
        },
        setCableVoltageLoss1000: (state, action) => {
            state.cableVoltageLoss1000 = action.payload
        },
        setCableMaxCondutorTemp: (state, action) => {
            state.cableMaxCondutorTemp = action.payload
        },
        setCableConductorTempDesign: (state, action) => {
            state.cableConductorTempDesign = action.payload
        },
        setCableAmpacity: (state, action) => {
            state.cableAmpacity = action.payload
        },
        setCableVDrop: (state, action) => {
            state.cableVDrop = action.payload
        },
        setWellCableList: (state, action) => {
            state.wellCableList = action?.payload ? Object.entries(action?.payload)?.map((records: any) => {
                return {
                    id: records[1].id,
                    label: records[0],
                    awgId: records[1].awgId,
                }
              }) : []
        },
        setLockPlateList: (state, action) => {
            state.lockPlateList = action.payload
        },
        setMotorLeadList: (state, action) => {
            state.motorLeadList = action.payload
        },
        setShowEquipmentTable: (state, action) => {
            state.ShowEquipmentTable = action.payload
        },
        ShowEquipmentCableTable: (state, action) => {
            state.ShowEquipmentCableTable = action.payload
        },
        setWellEquipmentList: (state, action) => {
            state.wellEquipmentList = action.payload
        },
        setSelectedWellEquipment: (state, action) => {
            state.selectedWellEquipment = action.payload
        },
        setMotorLockEquipmentList: (state, action) => {
            state.motorLockEquipmentList = action.payload
        },
        setSelectedWellLockEquipment: (state, action) => {
            state.selectedWellLockEquipment = action.payload
        },
        setCableClearance: (state, action) => {
            state.cableClearance = action.payload
        },
        setTubingCableChart: (state, action) => {
            state.tubingCableChart = action.payload
        },
        setPumpMotorLeadChart: (state, action) => {
            state.pumpMotorLeadChart = action.payload
        },
        setSealMotorLeadChart: (state, action) => {
            state.sealMotorLeadChart = action.payload
        },
        setMotorChart: (state, action) => {
            state.motorChart = action.payload
        },
        setCableCalculationComplete: (state, action) => {
            state.cableCalculationComplete = action.payload
        },
        setSelectedCable: (state, action) => {
            state.selectedCable = action.payload
        },
        resetCableFields: (state) => {
            state.cableTotalLength = 0;
            state.cableVoltageLoss1000 = 0;
            state.cableMaxCondutorTemp = 0;
            state.cableConductorTempDesign = 0;
            state.cableAmpacity = 0;
            state.cableVDrop = 0;
            state.cableTotalVoltageLoss = 0;
            state.cableSurfaceVoltage = 0;
            state.tubingCableChart = null;
            state.cableClearance = null;
        },

    },
})

export const {
    resetCableOutput,
    setCableTotalLength,
    setCableSurfaceVoltage,
    setCableTotalVoltageLoss,
    setCableVoltageLoss1000,
    setCableMaxCondutorTemp,
    setCableConductorTempDesign,
    setCableAmpacity,
    setCableVDrop,
    setWellCableList,
    setLockPlateList,
    setMotorLeadList,
    setShowEquipmentTable,
    ShowEquipmentCableTable,
    setWellEquipmentList,
    setSelectedWellEquipment,
    setMotorLockEquipmentList,
    setSelectedWellLockEquipment,
    setCableClearance,
    setTubingCableChart,
    setPumpMotorLeadChart,
    setSealMotorLeadChart,
    setMotorChart,
    setCableCalculationComplete,
    resetCableFields,
    setSelectedCable
} = cableSlice.actions;

export default cableSlice.reducer